var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 10.4999L10.4999 7.99992M10.4999 7.99992L7.99992 5.49992M10.4999 7.99992H1.33325M5.49992 4.04041V4.00008C5.49992 3.06666 5.49992 2.5996 5.68157 2.24308C5.84136 1.92948 6.09615 1.6747 6.40975 1.51491C6.76627 1.33325 7.23333 1.33325 8.16675 1.33325H12.0001C12.9335 1.33325 13.3996 1.33325 13.7561 1.51491C14.0697 1.6747 14.3253 1.92948 14.4851 2.24308C14.6666 2.59925 14.6666 3.06575 14.6666 3.99734V12.0029C14.6666 12.9345 14.6666 13.4003 14.4851 13.7565C14.3253 14.0701 14.0697 14.3253 13.7561 14.4851C13.3999 14.6666 12.9341 14.6666 12.0025 14.6666H8.16401C7.23241 14.6666 6.76592 14.6666 6.40975 14.4851C6.09615 14.3253 5.84136 14.0698 5.68157 13.7562C5.49992 13.3997 5.49992 12.9333 5.49992 11.9999V11.9583",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.51bf28c5b3c0435345f1d065e8514029.svg";
export { ForwardRef as ReactComponent };